const MiniQ2Table = ({item, t}) => {
    const SENSORS = {
        0: "A",
        1: "B",
        2: "AB"
    }
    return <>

        <div className="d-inline-block text-center ps-2 pe-3 border-end">
            <div className="fw-medium">{t("confsens")}</div>
            <div>{SENSORS[item.values.confsens]}</div>
        </div>
        {
            item.values.dist_p0 > 0 &&
            <div className="d-inline-block text-center ps-2 pe-3 border-end">
                <div className="fw-medium">{t("threshold")} RX P0</div>
                <div>{item.values.pot_rx_p0}</div>
            </div>

        }
        {
            item.values.dist_p1 > 0 &&
            <div className="d-inline-block text-center ps-2 pe-3 border-end">
                <div className="fw-medium">{t("threshold")} RX P1</div>
                <div>{item.values.pot_rx_p1}</div>
            </div>
        }
        {
            item.values.dist_p2 > 0 &&
            <div className="d-inline-block text-center ps-2 pe-3 border-end">
                <div className="fw-medium">{t("threshold")} RX P2</div>
                <div>{item.values.pot_rx_p2}</div>
            </div>
        }
        {
            item.values.dist_p3 > 0 &&
            <div className="d-inline-block text-center ps-2 pe-3 border-end">
                <div className="fw-medium">{t("threshold")} RX P3</div>
                <div>{item.values.pot_rx_p3}</div>
            </div>
        }


    </>
}
export default MiniQ2Table